import {IGroup,PagingType} from "@backend/types"
import {groupActions} from "./service"

type GroupState = {
    groups?: PagingType<IGroup>
}

export function groupReducer(state: GroupState = {}, action): GroupState {

    switch (action.type) {
        case groupActions.actionTypes.LIST: {
            const groups: PagingType<IGroup> = action.payload
            return {groups}
        }

        case groupActions.actionTypes.CLEAR: {
            return {}
        }

        case groupActions.actionTypes.DELETE: {
            const groupId = action.payload
            const {groups: stateGroups} = state

            if (stateGroups) {
                stateGroups.docs = stateGroups.docs.filter(group => group._id !== groupId)
                stateGroups.totalDocs -= 1
            }

            return {groups: {...stateGroups}}
        }

        default:
            return state
    }
}
